import type { SVGProps } from 'react';

const SvgAnnotationPencil = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20.71 9.29a.996.996 0 0 0-1.41 0l-6.23 6.23c-.38 0-.97-.07-1.3-.4-.24-.24-.33-.64-.3-1.18l6.24-6.24a.996.996 0 1 0-1.41-1.41l-6.24 6.24c-.54.03-.94-.06-1.17-.29-.33-.32-.4-.91-.4-1.3l6.23-6.23a.996.996 0 1 0-1.41-1.41l-8.02 7.99c-.13.13-.22.29-.26.46l-2 8c-.09.34.01.7.26.95.19.19.45.29.71.29.08 0 .16 0 .24-.03l8-2c.18-.04.34-.14.46-.26l8-8a.996.996 0 0 0 0-1.41zM9.47 14.53c.09.99.5 1.63.88 2.01.28.28.59.47.9.62l-3.16.79c-.21-.33-.51-.72-.92-1.12s-.8-.71-1.12-.92l.79-3.16c.15.32.34.63.61.91.38.38 1.02.79 2.01.88z"
    />
  </svg>
);
export default SvgAnnotationPencil;
